<template>
  <project-layout :projectName="this.$options.name">
    <p>Teamable is a mobile application that allows amateur athletes to easily set up matches and efficiently manage their teams.</p>
    <img :src="imagePath + 'works-teamable-01.png'" :alt="this.$options.name" class="mw630"/>
    <p>Managing an amateur sports team is unnecessarily time-consuming. Every time a team has a game, the manager has to check which members can attend, mostly by texting or making phone calls. Setting up a game isn't easy either.</p>
    <div class="cols col-3">
      <img :src="imagePath + 'works-teamable-02.png'" :alt="this.$options.name" class="border" />
      <img :src="imagePath + 'works-teamable-03.png'" :alt="this.$options.name" class="border" />
      <img :src="imagePath + 'works-teamable-04.png'" :alt="this.$options.name" class="border" />
    </div>
    <p>Finding a local team to play against is difficult, and the teams use various Meetup-type services to manage their teams, which disperses them over different databases. Teamable is designed to solve these problems and simplify the tasks.</p>
    <div class="cols col-3">
      <img :src="imagePath + 'works-teamable-05.png'" :alt="this.$options.name" class="border" />
      <img :src="imagePath + 'works-teamable-06.png'" :alt="this.$options.name" class="border" />
      <img :src="imagePath + 'works-teamable-07.png'" :alt="this.$options.name" class="border" />
    </div>
    <em class="desc">Teamable mobile app</em>
    <div class="cols col-3-row-2">
      <img :src="imagePath + 'works-teamable-detail-01.jpg'" :alt="this.$options.name" class="border circle" />
      <img :src="imagePath + 'works-teamable-detail-02.jpg'" :alt="this.$options.name" class="border circle" />
      <img :src="imagePath + 'works-teamable-detail-03.jpg'" :alt="this.$options.name" class="border circle" />
      <img :src="imagePath + 'works-teamable-detail-04.jpg'" :alt="this.$options.name" class="border circle" />
      <img :src="imagePath + 'works-teamable-detail-05.jpg'" :alt="this.$options.name" class="border circle" />
      <img :src="imagePath + 'works-teamable-detail-06.jpg'" :alt="this.$options.name" class="border circle" />
    </div>
    <img :src="imagePath + 'works-teamable-09.png'" :alt="this.$options.name" class="mw280" />
    <p>The process of designing Teamable was more iterative than incremental. We have continuosly done testing with couple of amateur football teams, and took the feedbacks from them seriously.</p>
    <div class="cols col-3">
      <img :src="imagePath + 'works-teamable-10.png'" :alt="this.$options.name" class="border" />
      <img :src="imagePath + 'works-teamable-11.png'" :alt="this.$options.name" class="border" />
      <img :src="imagePath + 'works-teamable-12.png'" :alt="this.$options.name" class="border" />
    </div>
    <em class="desc">Earlier version of Teamable app</em>
    <img :src="imagePath + 'works-teamable-13.jpg'" :alt="this.$options.name" />
    <img :src="imagePath + 'works-teamable-14.jpg'" :alt="this.$options.name" />
  </project-layout>  
</template>

<script>
  import ProjectLayout from '@/layouts/ProjectLayout.vue'
  import DataPath from '@/components/DataPath.vue'

  export default {
    name: 'teamable',
    components: {
      'project-layout': ProjectLayout
    },
    data () {
      return {
        imagePath: '',
        videoPath: ''
      }
    },
    created () {
      this.imagePath = DataPath.data().imagePath + this.$options.name + '/'
      this.videoPath = DataPath.data().videoPath + this.$options.name + '/'
    }
  }
</script>

<style lang="sass" scoped>
</style>


// WEBPACK FOOTER //
// src/contents/Teamable.vue